import {ADMIN_ROLES} from "../../shared/auth/roles";
import {i18n} from "../../shared/i18n";


export const createEmptyNewsDraft = () => ({
    article_id: null,
    title: "",
    text: "",
    ru_title: "",
    ru_text: "",
    kk_title: "",
    kk_text: "",
    ky_title: "",
    ky_text: "",
    city: "",
});

export const newsDetailToDraft = (detail = {}) => ({
    ...createEmptyNewsDraft(),
    article_id: detail.id ?? detail.article_id ?? null,
    title: String(detail.title ?? detail.ru_title ?? ""),
    text: String(detail.text ?? detail.ru_text ?? ""),
    city: detail.city && detail.city !== "-" ? String(detail.city) : "",
});

const normalized = (value) => String(value ?? "").trim();

const CREATE_FIELDS = [
    ["ru_title", i18n.t("sections.content.p316")],
    ["ru_text", i18n.t("sections.content.p317")],
    ["kk_title", i18n.t("sections.content.p318")],
    ["kk_text", i18n.t("sections.content.p319")],
    ["ky_title", i18n.t("sections.content.p320")],
    ["ky_text", i18n.t("sections.content.p321")],
];

export const validateNewsDraft = (draft = {}, {mode = "create"} = {}) => {
    if (mode === "edit") {
        const errors = {};
        if (!normalized(draft.title)) errors.title = i18n.t("sections.content.p322");
        if (!normalized(draft.text)) errors.text = i18n.t("sections.content.p323");
        return errors;
    }

    return Object.fromEntries(
        CREATE_FIELDS.filter(([field]) => !normalized(draft[field])).map(([field, message]) => [field, message]),
    );
};

export const newsDraftToPayload = (draft = {}, {mode = "create"} = {}) => {
    if (mode === "edit") {
        return {
            article_id: Number(draft.article_id),
            title: normalized(draft.title),
            text: normalized(draft.text),
            ...(normalized(draft.city) ? {city: normalized(draft.city)} : {}),
        };
    }

    return {
        ru_title: normalized(draft.ru_title),
        ru_text: normalized(draft.ru_text),
        kk_title: normalized(draft.kk_title),
        kk_text: normalized(draft.kk_text),
        ky_title: normalized(draft.ky_title),
        ky_text: normalized(draft.ky_text),
        ...(normalized(draft.city) ? {city: normalized(draft.city)} : {}),
    };
};

export const canMutateContentScope = ({role, countryScope, actorCountryId}) => {
    const selected = String(countryScope ?? "").trim();
    const actor = String(actorCountryId ?? "").trim();
    if (!/^[1-9]\d*$/.test(selected)) return false;
    return role === ADMIN_ROLES.SUPERADMIN || selected === actor;
};

export const validateMediaFile = (file, {allowVideo = false} = {}) => {
    if (!file) return i18n.t("sections.content.p324");
    const type = String(file.type || "").toLowerCase();
    if (type.startsWith("image/")) return "";
    if (allowVideo && type.startsWith("video/")) return "";
    return allowVideo ? i18n.t("sections.content.p325") : i18n.t("sections.content.p326");
};

export const moveMediaItem = (items = [], itemId, direction) => {
    const next = [...items];
    const currentIndex = next.findIndex((item) => String(item.id) === String(itemId));
    const targetIndex = direction === "up" ? currentIndex - 1 : currentIndex + 1;
    if (currentIndex < 0 || targetIndex < 0 || targetIndex >= next.length) return next;
    [next[currentIndex], next[targetIndex]] = [next[targetIndex], next[currentIndex]];
    return next;
};
